import React from 'react'
import { Wrapper, ActionWrapper, Title } from './Banner.styles'

interface BannerProps {
  className?: string
  'data-testid'?: string
  title: string
  text: React.ReactNode
  action?: React.ReactNode
}

const Banner: React.FC<BannerProps> = props => {
  const { className, 'data-testid': dataTestId, title, text, action } = props

  return (
    <Wrapper className={className} data-testid={dataTestId}>
      <Title>{title}</Title>
      {text}
      {action && <ActionWrapper>{action}</ActionWrapper>}
    </Wrapper>
  )
}

export default Banner
